import {RiEarthLine, RiFlaskLine, RiShareLine, RiStackLine, RiTeamLine, RiListCheck3} from "react-icons/ri";
import React from "react";

export const VEGA_BLOCK_LANGS = new Set(["chartjs", "vegalite", "vega-lite"]);
export const WORKFLOW_BLOCK_LANGS = new Set(["workflow", "workflow-plan", "workflow_plan", "scenario", "scenarios"]);

export const STACK_ICONS = {
  orchestrator: <RiStackLine size={20} style={{ marginLeft: 6, verticalAlign: "middle" }} />,
  swarm: <RiTeamLine size={20} style={{ marginLeft: 6, verticalAlign: "middle" }} />,
  generalist: <RiShareLine size={20} style={{ marginLeft: 6, verticalAlign: "middle" }} />,
  challenger: <RiEarthLine size={20} style={{ marginLeft: 6, verticalAlign: "middle" }} />,
  researcher: <RiFlaskLine size={20} style={{ marginLeft: 6, verticalAlign: "middle" }} />,
  evaluator: <RiListCheck3 size={20} style={{ marginLeft: 6, verticalAlign: "middle" }} />
};

export const STACK_TOOLTIPS = {
  orchestrator: "Orchestrator: Routes questions to the best-suited agents and synthesizes their answers",
  swarm: "Swarm: Multi-agent debate mode for comprehensive analysis",
  workflow: "Workflows: Run multi-step AI pipelines — search, extract, analyze, and synthesize",
  generalist: "Generalist: Versatile, general-purpose AI assistant.",
  challenger: "Challenger: Provides diverse perspectives and global insights.",
  researcher: "Researcher: Specialized for research and scientific queries.",
  evaluator: "Evaluator: Assesses answer quality, accuracy, and completeness."
};

export const AGENT_ORDER = [
  "orchestrator",
  "generalist",
  "challenger",
  "researcher",
  "evaluator",
];

// For the primary action buttons (Ask, Start Swarm, etc)
export const askButtonStyle = {
  height: "2.5rem",
  padding: "0 1.2rem",
  borderRadius: "4px",
  fontWeight: "bold",
  lineHeight: "1.2",
  verticalAlign: "middle",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  minWidth: "140px" // Unified minimum width for all primary buttons
};
